import { type T, Translate } from '../i18n';
import { m } from '../mithril';
import { addStyles } from './theme';

const CSS = {
	container: 'c-CenteredMessage',
};

const Style = {
	[CSS.container]: {
		height: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		textAlign: 'center',
	},
};

addStyles(Style);

export const CenteredMessage = {
	view(message: T) {
		return m('div', { className: CSS.container }, Translate(message));
	},
};
